export let WP_URL: string;
export let LOGOUT_URL: string;
export let FRONT_OFFICE_URL: string;
export let SESSION_COOKIE_NAME: string;
export let DEFAULT_PROFILE_PHOTO: string;
export let CDN_URL: string;
export let LANGUAGE_KEY: string;
export let COUNTRY_KEY: string;
export let COUNTRY_CODE: string;
export let COOKIES_DOMAIN: string;

export const USER_PHOTO_STORAGE_KEY: string = "photoProfile";
export const USER_PHOTO_COOKIE_KEY: string = "photo_session";
export const PROFILE_TIMESTAMP_STORAGE_KEY: string = "profile_session";
export const PROFILE_TIMESTAMP_COOKIE_KEY: string = "profile_session";

declare global {
  interface Window {
    dataLayer: any[];
    changeUser: Function;
  }
}

$(() => {
  WP_URL = $("#mainSettings").attr("data-WP_URL")!;
  LOGOUT_URL = $("#mainSettings").attr("data-LOGOUT_URL")!;
  FRONT_OFFICE_URL = $("#mainSettings").attr("data-FRONT_OFFICE_URL")!;
  SESSION_COOKIE_NAME = $("#mainSettings").attr("data-SESSION_COOKIE_NAME")!;
  DEFAULT_PROFILE_PHOTO = $("#mainSettings").attr(
    "data-DEFAULT_PROFILE_PHOTO"
  )!;
  COOKIES_DOMAIN = $("#mainSettings").attr("data-SESSION_COOKIE_DOMAIN")!;
  CDN_URL = $("#mainSettings").attr("data-CDN_URL")!;
  LANGUAGE_KEY = $("#mainSettings").attr("data-LANGUAGE_KEY")!;
  COUNTRY_KEY = $("#mainSettings").attr("data-COUNTRY_KEY")!;
  COUNTRY_CODE = $("#mainSettings").attr("data-COUNTRY_CODE")!;
  LOGOUT_URL = LOGOUT_URL.replace(
    "{urlCulture}",
    COUNTRY_KEY.toLocaleLowerCase().concat(
      "/",
      LANGUAGE_KEY.toLocaleLowerCase()
    )
  );
});
